import React from 'react'
import { makeStyles } from '@material-ui/core'
import HMapDisplayNew from '../../components/HMapDisplayNew'
import HMapDisplaySort from '../../components/HMapDisplaySort'
import HMapDisplaySearch from '../../components/HMapDisplaySearch'
import { HMapPanels } from '../../const/HMapPanels'
import { useHMapContext } from '../../hooks/useHMapContext'

const HMapDisplayTabHeaderInfo = ({
  mapsCount,
  setCurrentPanel,
  currentTab,
}) => {
  const classes = useStyles()
  const { currentHeatmapType, sortSearchInfo } = useHMapContext()
  const [, setHeatmapType] = currentHeatmapType
  const [sortSearch, setSortSearch] = sortSearchInfo

  const handleNewHeatmapClick = () => {
    setCurrentPanel(HMapPanels.HMapDetailsNew)

    const heatmapType = ['active', 'my'].includes(currentTab)
      ? 'user'
      : currentTab
    setHeatmapType(heatmapType)
  }

  return (
    <>
      <div className={classes.bottom}>
        <div className={classes.left}> {mapsCount} HeatMaps</div>
        <div className={classes.right}>
          <HMapDisplaySearch
            currentTab={currentTab}
            sortSearch={sortSearch}
            setSortSearch={setSortSearch}
          />
          <HMapDisplaySort
            currentTab={currentTab}
            sortSearch={sortSearch}
            setSortSearch={setSortSearch}
          />
          <HMapDisplayNew onClick={handleNewHeatmapClick} />
        </div>
      </div>
    </>
  )
}

export default React.memo(HMapDisplayTabHeaderInfo)

const useStyles = makeStyles((theme) => ({
  bottom: {
    width: '100%',
    padding: '5px 15px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    borderBottom: `1px solid ${theme.palette.secondary.main}`
  },
  left: {
    width: '35%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    ...theme.typography.h3,
    color: '#888'
  },
  right: {
    width: '65%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    '&> div': {
      marginRight: '5px'
    },
    '&> svg': {
      marginRight: '0px'
    },
    '&> :last-child': {
      marginRight: '0px'
    }
  }
}))
